import { z } from 'zod';

import { uuidValidator } from '../../validators';

export const UserResourceLinkTypeResponseSchema = z.object({
  id: uuidValidator,
  name: z.string(),
  userId: uuidValidator,
});

export type IUserResourceLinkTypeResponseDto = z.infer<
  typeof UserResourceLinkTypeResponseSchema
>;
